import { lazy } from "react";
import type { AppModule } from "../types";
import de from "./i18n/de.json";
import en from "./i18n/en.json";
import fr from "./i18n/fr.json";
import ru from "./i18n/ru.json";

const SchoolPage = lazy(() => import("./SchoolPage"));

export const schoolModule: AppModule = {
  id: "school",
  hasBackend: true,
  nav: { i18nKey: "modules.school.nav", group: "core" },
  routes: [{ path: "/school", Component: SchoolPage }],
  i18n: { de, en, fr, ru },
};
